import { render, staticRenderFns } from "./CommitmentAnalysis.vue?vue&type=template&id=baaf724a&scoped=true"
import script from "./CommitmentAnalysis.vue?vue&type=script&lang=js"
export * from "./CommitmentAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CommitmentAnalysis.vue?vue&type=style&index=0&id=baaf724a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaf724a",
  null
  
)

export default component.exports